export function formatDuration(seconds: number | null): string {
  if (seconds == null) return '-'
  const h = Math.floor(seconds / 3600)
  const m = Math.floor((seconds % 3600) / 60)
  return `${h}h ${m.toString().padStart(2, '0')}m`
}

import { t } from '@lingui/macro'

export function closureTypeLabel(type: string | null): string {
  switch (type) {
    case 'manual':
      return t`Manual`
    case 'browser_close':
      return t`Browser close`
    case 'forced_second_device':
      return t`Forced (2nd device)`
    case 'admin_close':
      return t`Admin`
    case 'automatic':
      return t`Automatic`
    case 'none':
    default:
      return '-'
  }
}
